import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            探索教程分类
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-xl mx-auto">
            六大分类体系覆盖P站视频使用的方方面面，无论你是新手还是老用户，都能找到需要的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-lg mb-4 ${
                  cat.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : 'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-3 text-sm text-primary-500 font-medium">
                <span>浏览教程</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}